//targetの中身にフォーカスされないようにする
const targets = document.querySelectorAll('.target');
targets.forEach((target) => {
  target.inert = true;
});

//
const toggleAction = (el) => {
  el.classList.toggle('active');
  const target = el.nextElementSibling;
  if (target.style.maxHeight) {
    target.style.maxHeight = null;
    target.inert = true;
  } else {
    target.inert = false;
    target.style.maxHeight = target.scrollHeight + 'px';
  }
};

const toggles = document.querySelectorAll('.toggle');
if (toggles) {
  toggles.forEach((toggle) => {
    toggle.addEventListener('click', function (e) {
      toggleAction(toggle);
    });

    toggle.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        toggleAction(toggle);
      }
    });
  });
}
